import { ItemSearch, ItemSearchSchema } from "@models/item";
import { createBrowseUrlParams, DEFAULT_SORT_KEY, DEFAULT_SORT_METHOD, ParsedBrowseUrl } from "@features/tickets/shared/utils/browseUrlParams";

export { DEFAULT_SORT_KEY, DEFAULT_SORT_METHOD };
export type ParsedItemsUrl = ParsedBrowseUrl<ItemSearch>;

const itemsBrowseUrl = createBrowseUrlParams<ItemSearch>(ItemSearchSchema);

export const parseItemsUrlParams = itemsBrowseUrl.parseBrowseUrlParams;
export const syncItemsUrlParams = itemsBrowseUrl.syncBrowseUrlParams;
